/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyPaper = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#E2E4EA"
      d="m117.231 25.642-73.98 4.627c-.096.006-.164.094-.137.187 4.073 14.023 8.622 50.269 3.243 67.767a.15.15 0 0 0 .082.18l35.893 16.5c9.729 3.983 30.859 3.619 37.55-29.699 6.663-33.18 1.127-53.427-2.515-59.493a.14.14 0 0 0-.136-.069"
    />
    <path stroke="#1E2024" strokeLinecap="round" strokeOpacity={0.8} d="m78.844 28.195 38.386-2.316" />
    <path
      fill="#E2E4EA"
      d="M21.155 100.859a.1.1 0 0 1 .069-.053l65.845-13.733c.099-.021.19.06.181.16l-.925 11.24c-.35 4.24.653 8.482 2.863 12.118l3.529 5.807a.15.15 0 0 1-.13.229H24.202a.1.1 0 0 1-.04-.01 10.397 10.397 0 0 1-4.093-13.528z"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      strokeOpacity={0.8}
      d="M87.6 91.174c-3.408 4.956-1.983 14.496 0 16.726M31.509 98.502l23.661-5.398"
    />
    <path
      fill="#CBCFD8"
      fillRule="evenodd"
      d="M29.71 73.741c10.443 11.34 28.19 11.986 39.638 1.442 11.448-10.543 12.264-28.282 1.821-39.622s-28.19-11.985-39.638-1.442c-11.448 10.544-12.263 28.283-1.82 39.622m4.343-4c8.234 8.941 22.245 9.433 31.295 1.099s9.711-22.338 1.478-31.279S44.58 30.13 35.53 38.463 25.82 60.8 34.053 69.742"
      clipRule="evenodd"
    />
    <path stroke="#000" d="M31.532 34.12a28.23 28.23 0 0 0-8.815 16.476" />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      strokeOpacity={0.8}
      d="M69.348 75.183a28.23 28.23 0 0 0 8.95-17.462"
    />
    <ellipse
      cx={50.44}
      cy={54.651}
      fill="#E2E4EA"
      opacity={0.4}
      rx={22.008}
      ry={22.276}
      transform="rotate(47.358 50.44 54.65)"
    />
    <path fill="#CBCFD8" d="m29.929 68.432 5.09 5.528L9.354 97.595a3.758 3.758 0 0 1-5.09-5.528z" />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      strokeOpacity={0.8}
      d="M4.074 97.41c.677.694 2.502 1.833 4.39.838M106.449 65.09c.175-2.665 8.088-19.705 19.215-15.425 2.912 1.12 3.812 4.617 3.452 7.204-.518 3.716-6.117 6.172-8.086 4.329-1.445-1.353-1.026-4.099.972-6.724 1.999-2.625 5.656-4.043 9.384-3.353s5.32 3.213 6.295 5.358M92.42 114.076c2.159 1.901 5.904 2.75 12.516-2.073"
    />
  </svg>
);
export default LegacyEmptyPaper;
